import { render, staticRenderFns } from "./UpdateInvitationMoneyWindow.vue?vue&type=template&id=247876cc&scoped=true"
import script from "./UpdateInvitationMoneyWindow.vue?vue&type=script&lang=js"
export * from "./UpdateInvitationMoneyWindow.vue?vue&type=script&lang=js"
import style0 from "./UpdateInvitationMoneyWindow.vue?vue&type=style&index=0&id=247876cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247876cc",
  null
  
)

export default component.exports